/*
  Acordeon de la seccion FAQs (sections/faqs.liquid).

  Otro componente cuyo JavaScript venia en el bundle que el proveedor servia
  bajo licencia. El markup y el CSS estan en el tema, pero sin logica: al pulsar
  una pregunta no ocurria nada.

  El punto clave esta en el CSS:

    .faq-answer      { max-height: 0; overflow: hidden; transition: max-height .4s }
    .faq-answer.open { padding-bottom: 1em }        <-- no define ninguna altura

  Anadir la clase .open NO basta para que se vea nada. Hay que fijar el
  max-height en linea con la altura real del contenido; por eso el CSS declara
  la transicion pero deja el valor abierto.
*/
(function () {
  var OPEN = 'open';

  function answerFor(question) {
    var item = question.closest('.faq-item');
    return item ? item.querySelector('.faq-answer') : null;
  }

  function open(question, answer) {
    question.classList.add(OPEN);
    answer.classList.add(OPEN);
    // Sin esta linea la respuesta sigue con max-height: 0 y no se despliega.
    answer.style.maxHeight = answer.scrollHeight + 'px';
    question.setAttribute('aria-expanded', 'true');
  }

  function close(question, answer) {
    question.classList.remove(OPEN);
    answer.classList.remove(OPEN);
    // Se limpia el valor en linea para que vuelva al 0 del CSS y se anime.
    answer.style.maxHeight = '';
    question.setAttribute('aria-expanded', 'false');
  }

  function closeSiblings(question) {
    var container = question.closest('.faq-container') || question.closest('.faq-section');
    if (!container) return;

    Array.prototype.forEach.call(container.querySelectorAll('.faq-question.' + OPEN), function (other) {
      if (other === question) return;
      var otherAnswer = answerFor(other);
      if (otherAnswer) close(other, otherAnswer);
    });
  }

  function toggle(question) {
    var answer = answerFor(question);
    if (!answer) return;

    if (question.classList.contains(OPEN)) {
      close(question, answer);
      return;
    }

    // data-allow-multiple lo pinta el Liquid en cada .faq-item.
    var item = question.closest('.faq-item');
    var allowMultiple = item && item.dataset.allowMultiple === 'true';
    if (!allowMultiple) closeSiblings(question);

    open(question, answer);
  }

  // Delegado en document: sigue funcionando cuando el editor de temas repinta
  // la seccion, sin tener que volver a enganchar nada.
  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var question = event.target.closest('.faq-question');
    if (question) toggle(question);
  });

  // Los .faq-question son <div>, no <button>: sin esto no habria forma de
  // abrirlos con teclado.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    if (!event.target || !event.target.closest) return;
    var question = event.target.closest('.faq-question');
    if (!question) return;
    event.preventDefault();
    toggle(question);
  });

  function makeFocusable(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('.faq-question'), function (question) {
      if (question.hasAttribute('tabindex')) return;
      question.setAttribute('tabindex', '0');
      question.setAttribute('role', 'button');
      question.setAttribute('aria-expanded', question.classList.contains(OPEN) ? 'true' : 'false');
    });
  }

  // Una altura fija en pixeles se queda corta si el texto se re-ajusta a otro
  // ancho, asi que las respuestas abiertas se recalculan al redimensionar.
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    if (resizeTimer) clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.faq-answer.' + OPEN), function (answer) {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      makeFocusable();
    });
  } else {
    makeFocusable();
  }

  // El editor de temas inserta secciones sin recargar la pagina.
  document.addEventListener('shopify:section:load', function (event) {
    makeFocusable(event.target);
  });
})();
